export default function numOnly(str: string) { return str?.replace(/\D/g, '') ?? ''; }
